import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { inject, onMounted, ref } from "vue";
import { ResourceServiceSymbol } from "@/InjectionSymbols";
import ResourceList from "@/components/admin/ResourceList.vue";
import { ResourceType } from "@/model/enum/ResourceType";
import ResourceGroupList from "@/components/admin/ResourceGroupList.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AttributeListView',
    setup(__props) {
        const resourceService = inject(ResourceServiceSymbol);
        const resources = ref([]);
        const resourceGroups = ref([]);
        onMounted(() => {
            resourceService.loadResources(ResourceType.ATTRIBUTE)
                .then(data => {
                resources.value = data;
            });
            resourceService.getResourceGroups(ResourceType.ATTRIBUTE)
                .then(response => {
                resourceGroups.value = response;
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(ResourceList, {
                    class: "mb-4",
                    resources: resources.value,
                    type: _unref(ResourceType).ATTRIBUTE
                }, null, 8, ["resources", "type"]),
                _createVNode(ResourceGroupList, {
                    "resource-groups": resourceGroups.value,
                    type: _unref(ResourceType).ATTRIBUTE
                }, null, 8, ["resource-groups", "type"])
            ], 64));
        };
    }
});
